import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import styled from "styled-components";
import i18n from "../i18n";

import { Button } from "ia-react-ui-components";

import Header from "./Header";
import PageErrorFooter from "./PageErrorFooter";
import GenerateInputArea from "./GenerateInputArea";
import Validation from "./Validation";
import ModalCancel from "./ModalCancel";

const LinkCancel = styled.a`
  body && {
    font-size: 16px;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
  }
`;

export class SectionFive extends Component {
  constructor(props) {
    super(props);

    let sessionInterview = JSON.parse(sessionStorage.getItem("interview"));

    if (sessionInterview) {
      this.props.interview.sections = sessionInterview.sections;
    }

    this.props.interview.lang = i18n.language.includes("en")? "en": "fr" ;

    this.state = {
      questions: this.props.interview.sections[this.props.step].questions,
      groups: this.props.interview.sections[this.props.step].groups,
      hideAccidentLink: this.props.interview.sections[this.props.step - 1]
        .hideSection,
      isValid: this.props.interview.sections[this.props.step].isValid,
      isModalVisible: false
    };
  }

  ////////////////////
  //Common Functions//
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  openModal = () => {
    this.setState({ isModalVisible: true });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };
  //End Common Functions//
  ////////////////////////

  //If an Accident, go back fill out Accident Section
  //Otherwise go back to Disability Section
  goToPage = direction => {
    this.save();

    if (direction === "previous") {
      if (this.state.hideAccidentLink === true) {
        this.props.history.push("/SectionThree");
      } else {
        this.props.history.push("/SectionFour");
      }
    } else {
      this.validate();
    }
  };

  validate = event => {
    if (
      Validation.validator(
        this.props.interview.sections[this.props.step].questions,
        this.props.interview.lang,
        this.props.interview.sections[this.props.step].groups
      ) === false
    ) {
      this.setState({ isValid: false }, () => {
        this.save();
      });
    } else {
      this.setState({ isValid: true }, () => {
        this.save(), this.props.history.push("/SectionSix");
      });
    }
  };

  save = () => {
    this.setState({ questions: this.props.questions });
    this.props.interview.sections[this.props.step].isValid = this.state.isValid;

    sessionStorage.setItem("interview", JSON.stringify(this.props.interview));
  };

  hideSec5Part1InfoHandler = (value, name) => {
    let groups = this.props.interview.sections[this.props.step].groups;

    switch (name) {
      case "q1":
        if (value === "1") {//Yes
          groups[0].hide = true;
          groups[4].hide = false;
        } else {
          groups[0].hide = false;
          groups[4].hide = true;
        }
        break;
      case "q11":
        if (value === "1") {//Yes
          groups[2].hide = false;
        } else {
          groups[2].hide = true;
        }
        break;
      default:
        break;
    }

    //Checkbox name holds both question name and option value
    //iA components only pass back name and value so in order to
    //evaluate and save the value correctly, name info holds both name
    //and option
    let checkboxName = name.substring(0, 3);
    let option = name.substring(3);

    switch (checkboxName) {
      case "q8a":
        if (option === "4") {
          if (value === true) {
            groups[1].hide = false;
          } else {
            groups[1].hide = true;
          }
        }
        break;
      case "q8b":
        if (option === "4") {
          if (value === true) {
            groups[3].hide = false;
          } else {
            groups[3].hide = true;
          }
        }
        break;
      default:
        break;
    }
    this.setState({ group: groups }, () => {
      this.props.interview.groups = this.state.groups;
    });
  };

  render() {
    const { t } = this.props;
    var questions = this.props.interview.sections[this.props.step].questions;
    var lang = this.props.interview.lang;

    var layout = [
      [["q1"]],
      [["q2a"], ["q3a"], ["q4a"], ["q5a"], ["q6a"], ["q7a"], ["q8a"]],
      [["q9a"], ["q10a"]],
      [["q11"]],
      [["q2b"], ["q3b"], ["q4b"], ["q5b"], ["q6b"], ["q7b"], ["q8b"]],
      [["q9b"], ["q10b"]],
      [["q12"], ["q13"], ["q14"], ["q15"], ["q16"], ["q17"], ["q18"]]
    ];

    return (
      <React.Fragment>
        <ModalCancel
          isVisible={this.state.isModalVisible}
          closeModal={this.closeModal}
          history={this.props.history}
          clearInterview={this.props.clearInterview}
        />

        <Header step={this.props.step + 1} lang={lang}/>

        <h1>
          {this.props.interview.lang === "en"
            ? this.props.interview.sections[this.props.step].name_e
            : this.props.interview.sections[this.props.step].name_f}
        </h1>
        <div className="injectIaStyles">
          <GenerateInputArea
            layout={layout[0]}
            lang={lang}
            questions={questions}
            hideHandler={this.hideSec5Part1InfoHandler}
          />
          <div hidden={this.state.groups[0].hide}>
            <GenerateInputArea
              layout={layout[1]}
              lang={lang}
              questions={questions}
              hideHandler={this.hideSec5Part1InfoHandler}
            />
            <div hidden={this.state.groups[1].hide}>
              <GenerateInputArea
                layout={layout[2]}
                lang={lang}
                questions={questions}
                hideHandler={this.hideSec5Part1InfoHandler}
              />
            </div>
            <GenerateInputArea
              layout={layout[3]}
              lang={lang}
              questions={questions}
              hideHandler={this.hideSec5Part1InfoHandler}
            />
            <div hidden={this.state.groups[2].hide}>
              <GenerateInputArea
                layout={layout[4]}
                lang={lang}
                questions={questions}
                hideHandler={this.hideSec5Part1InfoHandler}
              />
              <div hidden={this.state.groups[3].hide}>
                <GenerateInputArea
                  layout={layout[5]}
                  lang={lang}
                  questions={questions}
                  hideHandler={this.hideSec5Part1InfoHandler}
                />
              </div>
            </div>
          </div>

          <div hidden={this.state.groups[4].hide}>
            <h2>{t("section_occupation.header2")}</h2>
            <GenerateInputArea
              layout={layout[6]}
              lang={lang}
              questions={questions}
              hideHandler={this.hideSec5Part1InfoHandler}
            />
          </div>

          <Row>
            <Col sm="2">
              <Button id="btnPrev" onClick={() => this.goToPage("previous")}>
                {t("common.previous")}
              </Button>
            </Col>
            <Col sm="2">
              <Button id="btnNext" onClick={() => this.goToPage("next")}>
                {t("common.next")}
              </Button>
            </Col>
            <Col sm="2">
              <div style={{ verticalAlign: "middle", lineHeight: "45px" }}>
                <LinkCancel onClick={this.openModal}>
                  {t("common.cancel")}
                </LinkCancel>
              </div>
            </Col>
            <Col sm="6">
              <div hidden={this.state.isValid}>
                <PageErrorFooter />
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default translate("translate")(SectionFive);
